export const SITE_URL = "https://gabrielamuttoni.com.br"

export const WHATSAPP_NUMBER = "5551993093330"

export const buildWhatsappLink = (prefill: string) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(prefill)}`

export const BUSINESS = {
  name: "Gabriela Muttoni — Terapeuta Integrativa",
  legalName: "Gabriela Muttoni",
  description:
    "Mestre Reiki, taróloga, terapeuta floral (Alkhemy Lab) e praticante de Barras de Access Consciousness em Porto Alegre — atendimentos presenciais e online.",
  telephone: "+55 51 99309-3330",
  url: SITE_URL,
  logo: `${SITE_URL}/icons/icon-512x512.png`,
  email: "",
  address: {
    streetAddress: "",
    addressLocality: "Porto Alegre",
    addressRegion: "RS",
    postalCode: "",
    addressCountry: "BR",
  },
  geo: {
    latitude: -30.0346,
    longitude: -51.2177,
  },
  areaServed: ["Porto Alegre", "Canoas", "Viamão", "Gravataí", "Brasil (online)"],
  priceRange: "$$",
  sameAs: [
    "https://www.instagram.com/gabrielamuttoni",
    "https://www.facebook.com/gabrielamuttoni",
  ],
  openingHours: ["Mo-Fr 09:00-19:00", "Sa 09:00-13:00"],
}

export const SERVICES = {
  reiki: {
    label: "Reiki",
    short: "Mestre Reiki Usui",
  },
  "taro-alquimico": {
    label: "Tarô Alquímico",
    short: "Leitura de tarô alquímico",
  },
  florais: {
    label: "Florais Alkhemy Lab",
    short: "Terapia floral Alkhemy Lab",
  },
  "barras-de-access": {
    label: "Barras de Access Consciousness",
    short: "Sessão de Barras de Access",
  },
} as const

export const SERVICE_PATHS = {
  reiki: "/reiki",
  "taro-alquimico": "/taro-alquimico",
  florais: "/florais",
  "barras-de-access": "/barras-de-access",
} as const
